import { Card, CardContent, createStyles, makeStyles } from "@material-ui/core";
import { SubscriptionCheckbox } from './SubscriptionCheckbox';
import React from "react";
import { fade } from '@material-ui/core/styles/colorManipulator';
import { useTranslation } from "react-i18next";
import { ISubscriptions } from "../types";

interface ISubscriptionCardProps extends ISubscriptions {
    onClick: (id: string) => void;
    isLarge?: boolean;
    active: boolean;
}

const useStyles = makeStyles((theme) => (
    createStyles({
        root: {
            width: "15rem",
            height: '12.5rem',
            margin: '0 0.25rem 0 0.25rem',
            cursor: "pointer",
            transition: "background-color 0.2s ease-in-out",
            [theme.breakpoints.down('sm')]: {
                width: '12.5rem',
                height: "10.5rem",
            },
            "&:hover": {
                border: `1px solid ${theme.palette.primary.main}AA`
            },
            "&:active": {
                border: `1px solid ${theme.palette.primary.main}DD`
            }
        },
        large: {
            width: "25rem",
            height: '7.5rem',
            margin: '0 0.25rem 0 0.25rem',
            cursor: "pointer",
        },
        active: {
            border: `1px ${theme.palette.primary.main} solid`,
            textShadow: "0px 0px 1px",
            boxShadow: `0px 0px 1px ${theme.palette.primary.main}, 
                        0px 0px 2px ${theme.palette.primary.main},
                        0px 0px 3px ${theme.palette.primary.main}99`
        },
        title: {
            display: "flex"
        },
        titleText: {
            fontSize: "1.4rem",
            marginTop: '0.21rem',
            marginLeft: '0.2rem',
            [theme.breakpoints.down('sm')]: {
                margin: 0,
                fontSize: '1.2rem',
                marginTop: "0.25rem"
            }
        },
        titleActive: {
            textShadow: "0px 0px 1px",
        },
        content: {
            display: 'flex',
            paddingLeft: '2.25rem',
            flexDirection: 'column',
            // paddingRight: '2.25rem',
            [theme.breakpoints.down('sm')]: {
                padding: 0
            }
        },
        largeContent: {
            flexDirection: 'row-reverse'
        },
        transaction: {
            padding: '0.5rem 1rem',
            borderRadius: "8px",
            fontSize: "0.95rem",
            color: theme.palette.secondary.main,
            backgroundColor: fade(theme.palette.secondary.main, 0.1),
            marginTop: "0.5rem",
            fontWeight: "normal",
            width: 'fit-content',
            [theme.breakpoints.down('sm')]: {
                fontSize: '0.75rem'
            }
        },
        largeText: {
            float: 'left',
            marginLeft: '1rem',
            [theme.breakpoints.down('sm')]: {

            }
        },
        monthText: {
            fontSize: "1rem",
            marginLeft: "0.25rem",
            color: theme.palette.text.secondary,
        }
    })
))

export function SubscriptionCard({
    active,
    id,
    name,
    priceOptions,
    onClick,
    isLarge,
    currency
}: ISubscriptionCardProps) {
    const classes = useStyles();
    const { t } = useTranslation();
    const { price, percent, tier } = priceOptions;
    const rootClass = isLarge ? classes.large : classes.root;
    return <Card key={id} onClick={() => onClick(id)} className={`${rootClass} ${active ? classes.active : ""}`}
        variant="outlined">
        <CardContent>
            <div className={classes.title}>
                <div>
                    <SubscriptionCheckbox checked={active} />
                </div>
                <div className={`${classes.titleText} ${active ? classes.titleActive : ''}`}>
                    {t(`signup.subscriptions.${name.toLowerCase()}`)}
                </div>
            </div>
            <div className={`${classes.content} ${isLarge ? classes.largeContent : ""}`}>
                <div className={isLarge ? classes.largeText : ""}>
                    {currency}{price}<span className={classes.monthText}>
                        /{t(`signup.subscriptions.${tier.toLowerCase()}`)}
                    </span>
                </div>
                <div className={classes.transaction}>
                    {percent}{t(`signup.newVenue.transactionFee${currency}`)}
                </div>
            </div>

        </CardContent>
    </Card>
}